export class StringUtils {
    static formatString(str: string, ...val: any[]) {
        for (let index = 0; index < val.length; index++) {
            str = str.replace(`{${index}}`, val[index].toString());
        }
        return str;
    }

    static suffixString(raw: string, suffix: string, maxlen: number) {
        return `${raw.substring(0, maxlen)} ${suffix}`;
    }

    /**
     * Returnerar en ny sträng där en extra sträng har lagts in på en specifik position
     * Ex:
     *
     * @example
     *
     * const greeting = "Hejdig";
     * const extraGreeting = " på ";
     * const newString = StringUtils.insertAt(greeting, 3, extraGreeting);
     * // newString = "Hej på dig"
     *
     * @param raw Strängen som ska förändras
     * @param index Positionen där str-strängen ska läggas
     * @param insertStr Strängen som ska läggas in
     * @returns En ny sträng där "str" har lagts in på position "index" i "raw"
     */
    static insertAt(raw: string, index: number, insertStr: string): string {
        return raw.substring(0, index) + insertStr + raw.substring(index);
    }

    static appendWithPunctuation(prev: string, next: string): string {
        const trimmedPrev = (prev || "").trim();
        const trimmedNext = (next || "").trim();
        if (!trimmedPrev) {
            return trimmedNext;
        }
        if (!trimmedNext) {
            return trimmedPrev;
        }

        const separator = trimmedPrev.endsWith(".") ? " " : ". ";
        return `${trimmedPrev}${separator}${trimmedNext}`;
    }
}
